module.exports = __webpack_public_path__ + "img/result-btn.77955d19.png";